import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

import { cn } from '#/lib/utils';

const DndSortableItem = ({
  id,
  children,
  className = '',
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        'flex min-h-0 items-center gap-2 overflow-hidden rounded-md border border-gray-200 bg-panel p-2',
        isDragging && 'opacity-60 shadow-sm',
        className,
      )}
    >
      <button
        type="button"
        className="flex shrink-0 cursor-grab items-center text-gray-400 hover:text-gray-600 active:cursor-grabbing"
        aria-label="拖曳排序"
        {...attributes}
        {...listeners}
      >
        <GripVertical className="size-4" />
      </button>
      <div className="min-w-0 flex-1">
        {children}
      </div>
    </div>
  );
};

DndSortableItem.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default DndSortableItem;
